import React from 'react'
import { getCardData } from '../../../common/services/website-card.service';
import storePersist from '../../../redux/storePersist';

const AboutUs = () => {
    const aboutUsContent: any= storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items,'ULIP_ABOUTUS'): null;
  return (
    <div className=' p-10'>
        <h1 className=' text-lg font-bold '> About Us</h1>
        {aboutUsContent && <div
              className="text-skin-base opacity-70 text-sm leading-7 lg:text-15px lg:leading-loose"
              dangerouslySetInnerHTML={{
                __html: aboutUsContent[0]?.fullDescription,
              }}
            />}      
    </div>
  )
}

export default AboutUs